var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13502 6.15802C3.17992 6.11007 3.23383 6.07143 3.29367 6.04432C3.35351 6.01721 3.4181 6.00216 3.48376 6.00002C3.54941 5.99788 3.61485 6.00871 3.67632 6.03187C3.7378 6.05504 3.7941 6.09009 3.84202 6.13502L7.50002 9.56502L11.158 6.13502C11.2548 6.04432 11.3837 5.99579 11.5163 6.0001C11.6489 6.00441 11.7743 6.06122 11.865 6.15802C11.9557 6.25483 12.0043 6.3837 11.9999 6.51629C11.9956 6.64887 11.9388 6.77432 11.842 6.86502L7.84202 10.615C7.74935 10.7019 7.62707 10.7503 7.50002 10.7503C7.37298 10.7503 7.2507 10.7019 7.15802 10.615L3.15802 6.86502C3.11007 6.82012 3.07143 6.76622 3.04432 6.70638C3.01721 6.64654 3.00216 6.58195 3.00002 6.51629C2.99788 6.45063 3.00871 6.3852 3.03187 6.32372C3.05504 6.26225 3.09009 6.20594 3.13502 6.15802Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/_chevron-down.8495f73b5b0090e60160ec944f7dc479.svg";
export { ForwardRef as ReactComponent };